import { calculateUniqueSkillScore } from '../components/Calculations/UniqueSkillScoreCalculator';
import { calculateStatScore } from '../components/Calculations/StatsScoreCalculator';
import { calculateAdjustedScore } from '../components/Calculations/SkillScoreCalculator';

const useTotalScore = ({
    selectedStars,
    uniqueSkillLevel,
    editableStats,
    activeSkills,
    aptitudes
}) => {
    // --- Total Score Calculation ---
    // This logic is lightweight and runs on every render to ensure immediate feedback.

    // 1. Unique Skill Score
    const uniqueScore = calculateUniqueSkillScore(selectedStars, uniqueSkillLevel);

    // 2. Stats Score
    let statsScore = 0;
    const statNames = ['Speed', 'Stamina', 'Power', 'Guts', 'Wit'];
    statNames.forEach(stat => {
        const val = editableStats ? editableStats[stat] : 0;
        statsScore += calculateStatScore(val || 0);
    });

    // 3. Skills Score
    let skillsScore = 0;

    // Create a set of active skill IDs (using Id_skill) for quick lookup
    const activeSkillIds = new Set(
        activeSkills
            .filter(item => item.active)
            .map(item => parseInt(item.skill.Id_skill, 10))
    );

    activeSkills.forEach(item => {
        if (item.active) {
            // Check if this skill has an upgrade that is ALSO active
            // upgrade_id refers to Id_skill
            if (item.skill.upgrade_id && activeSkillIds.has(parseInt(item.skill.upgrade_id, 10))) {
                // Skip score calculation for this base skill because its upgrade is active
                return;
            }

            const result = calculateAdjustedScore(item.skill, aptitudes);
            skillsScore += result.adjustedScore;
        }
    });

    return {
        totalScore: uniqueScore + statsScore + skillsScore
    };
};

export default useTotalScore;
// Revisado: 2025-12-16
